<template>
  <div class="flow-wrapper">
    <FormulaRenderer
      :updateAlternative="updateAlternative"
      :questions_groups_index="questions_groups_index"
      :alternative="alternative"
      :question_index="question_index"
      :id="`${groupIndex}-${questionIndex}-alternative-show-when`"
      :label="alternativesRenderConfig.onlyRenderWhen.label[language]"
      :noIndent="true"
      :allowFirstRemoval="true"
      conditionsProperty="onlyRenderWhen"
    />
  </div>
</template>

<script>
import { alternativesRenderConfig } from '@/utils/alternativeOptions'

import FormulaRenderer from '../../FormulaRenderer.vue'

const { default: translations, ...translationKeys } = {}

export default {
  name: 'RenderFlowOption',

  components: {
    FormulaRenderer,
  },

  props: {
    updateAlternative: {
      required: true,
      type: Function,
    },

    questions_groups_index: {
      required: true,
      type: Number,
    },

    question_index: {
      required: true,
      type: Number,
    },

    alternative: {
      required: true,
      type: Object,
    },
  },

  data() {
    return {
      translations,
      ...translationKeys,
      alternativesRenderConfig,
    }
  },

  computed: {},

  methods: {},
}
</script>

<style lang="scss" scoped></style>
